import { makeGraphQLRequest } from '../utils/requestUtils';

export default async function createRFQ(userId, rfqInput) {
  let solNum
  let participants
  let partNum
  let niin
  let partDesc
  let drawingNums
  let qty
  let releaseQty
  if (rfqInput) {
    solNum = rfqInput.solNum
    participants = rfqInput.participants
    partNum = rfqInput.partNum
    niin = rfqInput.niin
    partDesc = rfqInput.partDesc
    drawingNums = rfqInput.drawingNums
    qty = rfqInput.qty
    releaseQty = rfqInput.releaseQty
  }

  const query = `mutation createRFQ($userId: ID, $solNum: String, $participants: [String], $partNum: String, $niin: String, $partDesc: String, $drawingNums: String, $qty: Float, $releaseQty: Float) { createRFQ (userId: $userId, solNum: $solNum, participants: $participants, partNum: $partNum, niin: $niin, partDesc: $partDesc, drawingNums: $drawingNums, qty: $qty, releaseQty: $releaseQty) { status msg rfqId  } }`;

  // Variables
  const variables = { userId, solNum, participants, partNum, niin, partDesc, drawingNums, qty, releaseQty };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  
  if (!response || !response.createRFQ) {
    console.error('CreateRFQ mutation failed:', response);
    return {
      status: 'error',
      msg: 'Failed to create RFQ',
      rfqId: null
    };
  }
  
  return response.createRFQ;
}




// WEBPACK FOOTER //
// ./src/graphql/sendRFQ.js